import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { isAuth } from "../../actions/auth";
import SubscriptionBanner from "../banner";

const Admin = (props) => {
  const { history, children } = props;
  const location = useLocation();

  useEffect(() => {
    if (!isAuth()) {
      history.replace(`/signin`);
    }
    if (
      isAuth()?.role !== "superadmin" &&
      location.pathname.includes("/admin")
    ) {
      history.replace(`/signin`);
    }
  }, []);
  return (
    <React.Fragment>
      {isAuth()?.role !== "superadmin" && <SubscriptionBanner />}
      {children}
    </React.Fragment>
  );
};
export default withRouter(Admin);
